import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography, withStyles } from '@material-ui/core';

const styles = () => ({
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  fileExtension: {
    marginTop: 'auto',
    marginLeft: '2px',
  },
});

function FileNameEditor({
  classes,
  open,
  handleUpdate,
  handleClose,
  fileName,
  fileExtension,
}) {
  const inputRef = React.useRef();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="rename-file-dialog"
    >
      <DialogTitle>Rename File</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`What would you like to rename ${fileName}.${fileExtension} to?`}
        </DialogContentText>
        <div className={classes.inputContainer}>
          <TextField
            inputRef={inputRef}
            autoFocus
            defaultValue={fileName}
            margin="dense"
            id="name"
            label="File Name"
            type="string"
            fullWidth
          />
          <Typography variant="body1" className={classes.fileExtension}>
            {`.${fileExtension}`}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
          color="primary"
        >
          {'Cancel'}
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleUpdate(true, `${inputRef.current.value}.${fileExtension}`);
          }}
          color="primary"
        >
          {'Change'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FileNameEditor.propTypes = {
  classes: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  fileExtension: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};

export default withStyles(styles)(FileNameEditor);
